var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ContentSection from "../../components/content-section";
import FooterSection from "../../components/footer-section";
export default function Home() {
    return (_jsxs("main", __assign({ className: "container px-4 space-y-9" }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-2" }, { children: [_jsx("h1", __assign({ className: "font-bold text-2xl leading-none font-sans text-[#022A59]" }, { children: "Formas de pagamento dos servi\u00E7os do Gov.pi" })), _jsx("p", __assign({ className: "text-[#404040] text-base tracking-wide leading-none" }, { children: "Confira as op\u00E7\u00F5es de pagamento e escolha a que for mais conveniente para voc\u00EA." }))] })), _jsx(ContentSection, { title: "Pix", subtitle: "Use o Pix para pagar de forma r\u00E1pida.", steps: [
                    {
                        iconName: "MousePointerClick",
                        label: "Selecione o serviço",
                        subtitle: "Selecione o serviço que deseja pagar.",
                    },
                    {
                        iconName: "DollarSign",
                        label: "Escolha pagar com Pix",
                        subtitle: "Escolha pagar com Pix.",
                    },
                    {
                        iconName: "QrCode",
                        label: "Pague com Pix",
                        subtitle: "Escaneie o QR Code pelo app do seu banco ou copie o código Pix e cole no app.",
                    },
                    {
                        iconName: "Smartphone",
                        label: "Confirme o pagamento",
                        subtitle: "Confira os dados e confirme o pagamento no app do banco.",
                    },
                ] }), _jsx(ContentSection, { title: "Boleto", subtitle: "Gere o boleto e pague at\u00E9 a data de vencimento.", steps: [
                    {
                        iconName: "MousePointerClick",
                        label: "Selecione o serviço",
                        subtitle: "Selecione o serviço que deseja pagar.",
                    },
                    {
                        iconName: "DollarSign",
                        label: "Escolha pagar com boleto",
                        subtitle: "Escolha pagar com boleto.",
                    },
                    {
                        iconName: "FileDown",
                        label: "Acesse o boleto",
                        subtitle: "Copie o código do boleto ou baixe o boleto para pagar.",
                    },
                    {
                        iconName: "ScanBarcode",
                        label: "Pague o boleto",
                        subtitle: "Pague o boleto no app do banco ou casa lotérica.",
                    },
                    {
                        iconName: "Smartphone",
                        label: "Aguarde",
                        subtitle: "A confirmação do pagamento pode levar até 3 dias úteis.",
                    },
                ] }), _jsx(ContentSection, { title: "Cart\u00E3o de cr\u00E9dito", subtitle: "Use seu cart\u00E3o para pagar o servi\u00E7o de IPVA com mais praticidade.", steps: [
                    {
                        iconName: "MousePointerClick",
                        label: "Selecione o serviço",
                        subtitle: "Selecione o serviço que deseja pagar.",
                    },
                    {
                        iconName: "DollarSign",
                        label: "Escolha pagar com cartão de crédito",
                        subtitle: "Escolha pagar com cartão de crédito.",
                    },
                    {
                        iconName: "CreditCard",
                        label: "Acesse o site externo",
                        subtitle: "Você será redirecionado para continuar.",
                    },
                    {
                        iconName: "ListTodo",
                        label: "Coloque os dados do seu cartão",
                        subtitle: "Confira os dados antes de continuar.",
                    },
                    {
                        iconName: "Check",
                        label: "Confirme o pagamento",
                        subtitle: "Confirme o pagamento para concluir.",
                    },
                ] }), _jsx(FooterSection, { title: "Servi\u00E7os com pagamento", bulletList: [
                    "Renovar CNH",
                    "Solicitar CNH Definitiva",
                    "Emitir Permissão Internacional Dirigir",
                    "Consultar e Pagar IPVA",
                    "Obter a Segunda Via da Minha CNH",
                    "Emitir Certidão Negativa CNH",
                    "Transferir Propriedade de Veículo",
                    "Emitir Licenciamento Anual do Veículo",
                ] }), _jsx(FooterSection, { title: "Fique atento ao pagar!", subtitle: "Confira as recomenda\u00E7\u00F5es para realizar pagamentos seguros.", warningList: [
                    "Gere a guia apenas pelo portal oficial",
                    "Confira o nome do beneficiário antes de pagar",
                    "Cuidado com links recebidos por mensagem",
                    "Não confie em cobranças enviadas por WhatsApp",
                ] })] })));
}
